/** Знак аптеки на экране входа: плитка бренда с крестом (как в прототипе). */
export function PharmacyMark() {
  return (
    <span className="mark" aria-hidden="true">
      <svg viewBox="0 0 24 24">
        <path d="M9 3h6v6h6v6h-6v6H9v-6H3V9h6z" fill="currentColor" />
      </svg>
    </span>
  )
}
